import React from 'react';
import { IconButton } from '@mui/material';
import useDownload from '../../../hooks/useDownload';
import DownloadIconWithtext from '../../atoms/DownloadIconWithtext';
var ShippingInstructionDownloadIcon = function (_a) {
    var type = _a.type, shippingInstruction = _a.shippingInstruction;
    var _b = getDownloadParams(shippingInstruction, type), path = _b.path, downloadFilename = _b.downloadFilename, displayName = _b.displayName;
    var download = useDownload({ path: path, downloadFilename: downloadFilename });
    if (shippingInstruction.status !== 'published')
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { onClick: download.handleDownload, disabled: download.downloading },
            React.createElement(DownloadIconWithtext, { title: displayName }))));
};
export default ShippingInstructionDownloadIcon;
var getDownloadParams = function (shippingInstruction, type) {
    var id = shippingInstruction.id, warehouseSeaport = shippingInstruction.warehouseSeaport;
    var displayName = "To ".concat(warehouseSeaport);
    switch (type) {
        case 'shippingInstruction':
            return {
                path: "/api/shipping_instructions/".concat(id, ".pdf"),
                downloadFilename: "shipping_instruction_#".concat(id, ".pdf"),
                displayName: displayName,
            };
        case 'commercialInvoice':
            return {
                path: "/api/shipping_instructions/".concat(id, "/commercial_invoice.pdf"),
                downloadFilename: "commercial_invoice_#".concat(id, ".pdf"),
                displayName: displayName,
            };
        case 'packingList':
            return {
                path: "/api/shipping_instructions/".concat(id, "/packing_list.pdf"),
                downloadFilename: "packing_list_#".concat(id, ".pdf"),
                displayName: displayName,
            };
        default:
            throw Error('unknown type');
    }
};
